import {
  RenderPage,
  editModal,
  openModal,
  resetFormState,
  setLoading,
  setTableLoading,
  updateRendererFormState,
  updateRendererState,
} from "../../slices/common/reducer";
import { showToast } from "../../common/Toaster/Toaster";
import rootReducer from "../../store";
import {
  confirmationModal,
  setAgMemberEditFieldJson,
  setAgMemberFieldJson,
  setAgMemberIdData,
  setEditCredential,
  setProfileFieldsJSON,
  setProfileJson,
  setProfileLayoutJSON,
} from "../../slices/agMember/agMemberSlice";
import api from "../../Utils/interface";

export const getAgMemberListing = (entityType, functionName) => {
  const setLoadingTimeout = setTimeout(() => {
    rootReducer.dispatch(setTableLoading(true));
  }, 300);
  let fd = new FormData();
  api
    .post(`/entity/readAll`, fd, {
      params: {
        entity_type: entityType,
      },
    })
    .then((res) => {
      rootReducer.dispatch(functionName(res.data));
      clearTimeout(setLoadingTimeout);
    })
    .catch((err) => {
      console.log(err);
      clearTimeout(setLoadingTimeout);
      rootReducer.dispatch(setTableLoading(false));
    });
};

export let createAgMember = async (entity, entityType, organizationid) => {
  const updatedEntity = {
    ...entity,
    entitytype: entityType,
    organizationid: organizationid,
  };
  let fd = new FormData();
  fd.append("entity", JSON.stringify(updatedEntity));
  fd.append("entitytype", entityType);

  await api
    .post(`/entity/create`, fd, {})
    .then((response) => {
      rootReducer.dispatch(RenderPage());
      rootReducer.dispatch(resetFormState());
      rootReducer.dispatch(openModal(false));
      rootReducer.dispatch(setLoading(false));
      showToast("Member added successfully", "success");
      // setLoading(false);
    })
    .catch((error) => {
      showToast(error?.response?.data?.error_message, "error");
      rootReducer.dispatch(setLoading(false))
    });
};

export const getAgMemberData = (entity_id, entity_type) => {
  let fd = new FormData();

  fd.append("entityid", entity_id);
  fd.append("entitytype", entity_type);
  api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      rootReducer.dispatch(setAgMemberIdData(res.data));
      rootReducer.dispatch(updateRendererFormState(res.data));
      // const profileJson = JSON.parse(res.data.profile_json);
      // if (profileJson) {
      //   rootReducer.dispatch(updateRendererFormState(profileJson));
      // } else {
      //   rootReducer.dispatch(updateRendererFormState(res.data));
      // }
      // console.log("Profile Json", profileJson);
      // rootReducer.dispatch(setProfileJson(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export let updateAgMember = async (entity, entityid, navigator) => {
  const { profile_json, ...filteredEntity } = entity;

  const updatedEntity = {
    ...filteredEntity,
    entityid: entityid,
    entitytype: "AGM",
  };

  let fd = new FormData();
  fd.append("entityid", entityid);
  fd.append("entitytype", updatedEntity.entitytype);
  fd.append("entity", JSON.stringify(updatedEntity));

  api
    .post(`/entity/update`, fd, {})
    .then((res) => {
      rootReducer.dispatch(resetFormState());
      showToast("Ag member updated successfully", "success");
      navigator("/agmember/member");
    })
    .catch((err) => {
      console.log(err);
      showToast(err?.response?.data?.error_message, "error");
    });
};

export let createAgFamilyMember = async (
  entity,
  entityType,
  organizationid,
  parentid
) => {
  const updatedEntity = {
    ...entity,
    entitytype: entityType,
    organizationid: organizationid,
    parentid: parentid,
  };
  let fd = new FormData();
  fd.append("entity", JSON.stringify(updatedEntity));
  fd.append("entitytype", entityType);

  await api
    .post(`/entity/create`, fd, {})
    .then((response) => {
      rootReducer.dispatch(RenderPage());
      rootReducer.dispatch(resetFormState());
      rootReducer.dispatch(openModal(false));
      showToast("Ag Member Family added successfully", "success");
    })
    .catch((error) => {
      showToast(error?.response?.data?.error_message, "error");
    });
};

export let updateAgFamilyMember = async (entity, entityid, organizationid) => {
  const excludedKeys = ["created_date", "modified_date"];

  const updatedEntity = Object.fromEntries(
    Object.entries(entity).filter(([key]) => !excludedKeys.includes(key))
  );

  let fd = new FormData();
  fd.append("entity", JSON.stringify(updatedEntity));
  fd.append("entityid", entityid);
  fd.append("entitytype", "AGFM");
  fd.append("organizationid", organizationid);

  api
    .post(`/entity/update`, fd, {})
    .then((res) => {
      rootReducer.dispatch(RenderPage());
      rootReducer.dispatch(resetFormState());
      rootReducer.dispatch(editModal(false));
      rootReducer.dispatch(openModal(false));
      showToast("Ag Member Family Updated Successfully!", "success");
    })
    .catch((err) => {
      console.log(err);
      showToast(err?.response?.data?.error_message, "error");
    });
};

export const getDropdownListOfRM = (ownerId, organizationId, fieldJson) => {
  const params = { ownerId, organizationId };
  api
    .get(`/agsp/customer/getDropdownListOfRM`, { params })
    .then((response) => {
      if (fieldJson) {
        const customValues = Array.isArray(response?.data)
          ? response.data.map((item) => ({
              label: item.name,
              value: item.user_id,
            }))
          : [];

        const updatedAgMemberFieldJson = {
          ...fieldJson,
          "1718616994611-customSelect": {
            ...fieldJson["1718616994611-customSelect"],
            "data-customvalue": customValues,
          },
        };
        const updatedAgMemberEditFieldJson = {
          ...fieldJson,
          "1718616994611-customSelect": {
            ...fieldJson["1718616994611-customSelect"],
            "data-customvalue": customValues,
          },
        };
        rootReducer.dispatch(setAgMemberFieldJson(updatedAgMemberFieldJson));
        rootReducer.dispatch(
          setAgMemberEditFieldJson(updatedAgMemberEditFieldJson)
        );
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getFormRenderer = async (parentId, organizationId) => {
  const fd = new FormData();

  fd.append("mappedEntityType", "PRF");
  fd.append("parentType", "AGRP");
  fd.append("parentId", parentId);
  fd.append("organizationId", organizationId);

  try {
    api.post(`/agsp/getViewMasterData`, fd).then((response) => {
      const profileLayoutJSON =
        typeof response.data.publishedformlayout === "string"
          ? JSON.parse(response.data.publishedformlayout)
          : response.data.publishedformlayout;

      const profileFieldsJSON =
        typeof response.data.publishedformfields === "string"
          ? JSON.parse(response.data.publishedformfields)
          : response.data.publishedformfields;

      rootReducer.dispatch(setProfileFieldsJSON(profileFieldsJSON));
      rootReducer.dispatch(setProfileLayoutJSON(profileLayoutJSON));
    });
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

export const updateFromRenderer = async (
  entity,
  entityid,
  entitytype,
  id,
  mode
) => {
  const excludedKeys = [
    "entitytype",
    "ag_name",
    "entityid",
    "parenttype",
    "parentid",
    "organizationid",
    "enterpriseid",
    "code",
    "created_date",
    "modified_date",
    "role_id",
    "user_id",
    "default_member_id",
    "is_first_login",
    "status",
    "created_by",
    "seq_no",
  ];

  // Filter the entity to remove unwanted fields
  const filteredEntity = Object.keys(entity).reduce((acc, key) => {
    if (!excludedKeys.includes(key)) {
      acc[key] = entity[key];
    }
    return acc;
  }, {});
  const fd = new FormData();
  const formattedEntity = {
    profile_json: JSON.stringify(filteredEntity),
  };
  fd.append("entity", JSON.stringify(formattedEntity));
  fd.append("entityid", entityid);
  fd.append("entitytype", entitytype);
  try {
    api.post(`/entity/update`, fd).then((response) => {
      return readAll(id, mode);
    });
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

export let updateCredentials = async (
  memberId,
  mobile,
  emailId,
  password,
  id,
  displayMode
) => {
  let fd = new FormData();
  fd.append("memberId", memberId);
  fd.append("mobile", mobile);
  fd.append("emailId", emailId);
  fd.append("password", password);
  api
    .post(`/agsp/customer/updateCredetials`, fd, {})
    .then((res) => {
      if (res && res.status === 200) {
        readAll(id, displayMode);
        showToast("Credential updated successfully", "success");
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      showToast(
        err?.response?.data?.error_message || "Error while updating",
        "error"
      );
    });
};

export const readProfileData = (memberId, displayMode) => {
  let fd = new FormData();

  fd.append("memberId", memberId);
  fd.append("displayMode", displayMode);

  api
    .post(`/agsp/customer/getProfileFormData`, fd, {})
    .then((res) => {
      rootReducer.dispatch(updateRendererState(res.data));
      // rootReducer.dispatch(setAgMemberIdData(res.data));
      rootReducer.dispatch(setProfileJson(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const readAll = (memberId, displayMode) => {
  let fd = new FormData();

  fd.append("memberId", memberId);
  fd.append("displayMode", displayMode);

  api
    .post(`/agsp/customer/getAffinityMemberData`, fd, {})
    .then((res) => {
      rootReducer.dispatch(updateRendererState(res.data));
      rootReducer.dispatch(setAgMemberIdData(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteAgMember = (memberId) => {
  let fd = new FormData();

  fd.append("memberId", memberId);
  api
    .post(`agsp/order/deleteAgMember`, fd, {})
    .then((res) => {
      showToast("AG Member deleted successfully", "success");
      rootReducer.dispatch(RenderPage());
    })
    .catch((err) => {
      console.log(err);
      showToast(err?.response?.data?.error_message, "error");
    });
};
